export default "__VITE_ASSET__D4Ym5wAn__"